import { useState, useEffect } from 'react';

function Juugs() {
    const [email, setEmail] = useState('');
    const [juugs, setJuugs] = useState([]);
    const [juugToDelete, setJuugToDelete] = useState(null);

    // SHOW JUUGS 
    useEffect(() => {
        if (!email) return;

        const fetchData = async () => {
            try {
                const res = await fetch(
                    `/juugs?email=${encodeURIComponent(email)}`
                );

                if (!res.ok) {
                    console.log('JUUGS NOT SHOWIN');
                    return;
                }

                const data = await res.json();
                setJuugs(data.juug);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, [email]);

    // DELETE JUUG
    async function deleteJuugs(name) {
        try {
            const res = await fetch(
                `/delete?email=${encodeURIComponent(email)}&name=${encodeURIComponent(name)}`,
                { method: "DELETE" }
            );

            if (!res.ok) {
                console.log('Did not delete');
                return;
            }

            const data = await res.json();
            console.log("Deleted:", data);

            // Update UI after delete
            setJuugs(prev => prev.filter(j => j.name !== name));
            setJuugToDelete(null);

        } catch (err) {
            console.error(err);
        }
    }

    return (
        <div>
            <p><b>Enter upload email:</b></p>
            <form onSubmit={e => e.preventDefault()}>
                <input type="text" onChange={(e) => setEmail(e.target.value)} />
            </form>

            <div>
                {juugs.map((item) => (
                    <div key={item.name}>
                        <p><strong>Name:</strong> {item.name}</p>
                        <p><strong>Song:</strong> {item.song}</p>

                        <button onClick={() => setJuugToDelete(item.name)}>
                            Delete Juug
                        </button>

                        {juugToDelete === item.name && (
                            <>
                                <p>Are you sure you want to delete this juug?</p>
                                <button onClick={() => deleteJuugs(item.name)}>Yes</button>
                                <button onClick={() => setJuugToDelete(null)}>Cancel</button>
                            </>
                        )}

                        <hr />
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Juugs;
